export default {"src":"/_next/static/media/leaf-bg-1.1045a309.svg","height":35,"width":41};